<template>
  <span
    v-if="validStatus"
    class="d-block text-white text-center"
    :style="`padding: 5px; background-color: ${validStatus.color};`"
    >{{
      validStatus.label.startsWith("Traité") ? "Traité" : validStatus.label
    }}</span
  >
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      prospectStatus: "getProspectStatus",
    }),

    validStatus() {
      return this.prospectStatus.find((s) => s.value === this.status);
    },
  },
};
</script>
